import React from 'react';
import { IdCard } from 'lucide-react';
import { NoMatriculado } from 'types/NoMatriculados';

interface Props {
  noMatriculado: Partial<NoMatriculado>;
}

export default function HomeActivo({
  noMatriculado,
}: Props) {
  return (
    <div className="d-flex justify-content-between align-items-center">
      {/* Izquierda: icono + título (una sola línea) */}
      <div className="d-flex align-items-center flex-shrink-0">
        <div
          style={{
            backgroundColor: '#F8E9FF',
            padding: 10,
            borderRadius: 30,
          }}
        >
          <IdCard
            color="#a13bd0"
            size={24}
            className=" text-secondary"
          />
        </div>

        <strong
          className="text-truncate"
          style={{
            maxWidth: '447px',
            marginLeft: 5,
            fontSize: '22px',
            fontFamily: 'Roboto',
            fontWeight: 500,
          }}
        >
          Solicitud de Matriculación
        </strong>
      </div>

      {/* Derecha */}
      <div className="d-flex align-items-center gap-3">
        <span
          className="text-muted"
          style={{
            maxWidth: '400px',
            fontSize: '0.9rem',
            lineHeight: 1.3,
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
            marginRight: '20px',
          }}
        >
          Tu matrícula fue creada con éxito. MP: <b>{noMatriculado?.matriculate?.MTR001_N_MATRICULA ?? ''}</b>
        </span>
      </div>
    </div>
  );
}
